import React, { useState } from "react";
import { QuizHeader } from "./shared";

const MIN = 1;
const MAX = 120;

const NumberInputStep = ({ step, prevStep, onAnswer, stepLabel }) => {
  const [value, setValue] = useState("");

  const num = Number(value);
  const isValid = value !== "" && num >= MIN && num <= MAX;

  const adjust = (delta) => {
    const next = Math.min(MAX, Math.max(MIN, (Number(value) || 0) + delta));
    setValue(String(next));
  };

  const submit = () => {
    if (isValid) onAnswer(num);
  };

  return (
    <section className="qz-step">
      <QuizHeader
        title={step.question}
        subtitle={step.subtitle}
        stepLabel={stepLabel}
        onBack={prevStep}
      />

      <div className="qz-number">
        <button type="button" className="qz-round" onClick={() => adjust(-1)} aria-label="Decrease age">
          &minus;
        </button>

        <div className="qz-number__field">
          <input
            className="qz-number__input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={3}
            value={value}
            placeholder="25"
            aria-label="Your age"
            onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 3))}
            onKeyDown={(e) => e.key === "Enter" && submit()}
          />
          <span className="qz-number__unit">years old</span>
        </div>

        <button type="button" className="qz-round" onClick={() => adjust(1)} aria-label="Increase age">
          +
        </button>
      </div>

      <div className="qz-actions">
        <button type="button" className="qz-btn qz-btn--primary" disabled={!isValid} onClick={submit}>
          Continue
        </button>
      </div>
    </section>
  );
};

export default NumberInputStep;